import React from 'react';
import { Rectangle, Layer } from 'recharts';

export default function DemoSankeyNode({
  x,
  y,
  width,         // matches Sankey's nodeWidth
  height,
  index,
  payload,
  containerWidth,
  totalValue,
  onClickNode
}) {
  const percentage = ((payload.value / totalValue) * 100).toFixed(0);
  const handleClick = () => onClickNode && onClickNode(payload.name);

  // estimate text width (roughly 7px per character)
  const approxWidth = payload.name.length * 7;
  // decide if it will overflow to the right
  const willOverflow = x + width + 6 + approxWidth > containerWidth;

  const textAnchor = willOverflow ? 'end' : 'start';
  const textX = x + width + 6;

  return (
    <Layer
      key={`CustomNode${index}`}
      onClick={handleClick}
      style={{ cursor: 'pointer', overflow: 'visible' }} // allow text to bleed out
    >
      <Rectangle
        x={x}
        y={y}
        width={width}
        height={height}
        fill="#7856ff"
        fillOpacity="1"
        radius={2}
      />
      <text
        textAnchor={'start'}
        x={textX}
        y={y + (height+10) / 2}
        fontSize="12"
        fill="#333"
        style={{ overflow: 'visible' }}
      >
        {payload.name.length > 20
          ? payload.name.substr(0, 20) + '…'
          : payload.name}{' '}
        ({percentage}%)
      </text>
    </Layer>
  );
}
